(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory(require("react"), require("classnames"), require("@material/react-ripple/dist/index.js"));else if (typeof define === 'function' && define.amd) define(["react", "classnames", "@material/react-ripple/dist/index.js"], factory);else {
    var a = typeof exports === 'object' ? factory(require("react"), require("classnames"), require("@material/react-ripple/dist/index.js")) : factory(root["react"], root["classnames"], root["@material/react-ripple/dist/index.js"]);

    for (var i in a) {
      (typeof exports === 'object' ? exports : root)[i] = a[i];
    }
  }
})(typeof self !== 'undefined' ? self : this, function (__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__) {
  return (
    /******/
    function (modules) {
      // webpackBootstrap

      /******/
      // The module cache

      /******/
      var installedModules = {};
      /******/

      /******/
      // The require function

      /******/

      function __webpack_require__(moduleId) {
        /******/

        /******/
        // Check if module is in cache

        /******/
        if (installedModules[moduleId]) {
          /******/
          return installedModules[moduleId].exports;
          /******/
        }
        /******/
        // Create a new module (and put it into the cache)

        /******/


        var module = installedModules[moduleId] = {
          /******/
          i: moduleId,

          /******/
          l: false,

          /******/
          exports: {}
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/

        /******/
        // Flag the module as loaded

        /******/

        module.l = true;
        /******/

        /******/
        // Return the exports of the module

        /******/

        return module.exports;
        /******/
      }
      /******/

      /******/

      /******/
      // expose the modules object (__webpack_modules__)

      /******/


      __webpack_require__.m = modules;
      /******/

      /******/
      // expose the module cache

      /******/

      __webpack_require__.c = installedModules;
      /******/

      /******/
      // define getter function for harmony exports

      /******/

      __webpack_require__.d = function (exports, name, getter) {
        /******/
        if (!__webpack_require__.o(exports, name)) {
          /******/
          Object.defineProperty(exports, name, {
            /******/
            configurable: false,

            /******/
            enumerable: true,

            /******/
            get: getter
            /******/

          });
          /******/
        }
        /******/

      };
      /******/

      /******/
      // getDefaultExport function for compatibility with non-harmony modules

      /******/


      __webpack_require__.n = function (module) {
        /******/
        var getter = module && module.__esModule ?
        /******/
        function getDefault() {
          return module['default'];
        } :
        /******/
        function getModuleExports() {
          return module;
        };
        /******/

        __webpack_require__.d(getter, 'a', getter);
        /******/


        return getter;
        /******/
      };
      /******/

      /******/
      // Object.prototype.hasOwnProperty.call

      /******/


      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/

      /******/
      // __webpack_public_path__

      /******/


      __webpack_require__.p = "";
      /******/

      /******/
      // Load entry module and return exports

      /******/

      return __webpack_require__(__webpack_require__.s = 10);
      /******/
    }(
    /************************************************************************/

    /******/
    [
    /* 0 */

    /***/
    function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_0__;
      /***/
    },
    /* 1 */

    /***/
    function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
      /***/
    },
    /* 2 */

    /***/
    function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
      /***/
    },,,,,,,,
    /* 3 */

    /* 4 */

    /* 5 */

    /* 6 */

    /* 7 */

    /* 8 */

    /* 9 */

    /* 10 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict"; // The MIT License
      //
      // Copyright (c) 2018 Google, Inc.
      //
      // Permission is hereby granted, free of charge, to any person obtaining a copy
      // of this software and associated documentation files (the "Software"), to deal
      // in the Software without restriction, including without limitation the rights
      // to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
      // copies of the Software, and to permit persons to whom the Software is
      // furnished to do so, subject to the following conditions:
      //
      // The above copyright notice and this permission notice shall be included in
      // all copies or substantial portions of the Software.
      //
      // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
      // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
      // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
      // AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
      // LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
      // OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
      // THE SOFTWARE.

      var __assign = this && this.__assign || function () {
        __assign = Object.assign || function (t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];

            for (var p in s) {
              if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
          }

          return t;
        };

        return __assign.apply(this, arguments);
      };

      var __rest = this && this.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var React = __webpack_require__(0);

      var classnames = __webpack_require__(1);

      var Ripple = __webpack_require__(2);

      var BUTTON_CLASS_NAME = 'mdc-button__icon';

      exports.Button = function (_a) {
        var _b = _a.className,
            className = _b === void 0 ? '' : _b,
            _c = _a.raised,
            raised = _c === void 0 ? false : _c,
            _d = _a.unelevated,
            unelevated = _d === void 0 ? false : _d,
            _e = _a.outlined,
            outlined = _e === void 0 ? false : _e,
            _f = _a.dense,
            dense = _f === void 0 ? false : _f,
            _g = _a.disabled,
            disabled = _g === void 0 ? false : _g,
            icon = _a.icon,
            href = _a.href,
            children = _a.children,
            initRipple = _a.initRipple,
            // eslint disabled since we do not want to include
        // this in ...otherProps.
        // if unbounded is passed to the <button> element, it will throw
        // a warning.
        _h = _a.unbounded,
            // eslint disabled since we do not want to include
        // this in ...otherProps.
        // if unbounded is passed to the <button> element, it will throw
        // a warning.
        unbounded = _h === void 0 ? false : _h,
            // eslint-disable-line no-unused-vars
        otherProps = __rest(_a, ["className", "raised", "unelevated", "outlined", "dense", "disabled", "icon", "href", "children", "initRipple", "unbounded"]);

        var props = __assign({
          className: classnames('mdc-button', className, {
            'mdc-button--raised': raised,
            'mdc-button--unelevated': unelevated,
            'mdc-button--outlined': outlined,
            'mdc-button--dense': dense
          }),
          ref: initRipple,
          disabled: disabled
        }, otherProps);

        if (href) {
          return React.createElement("a", __assign({}, props, {
            href: href
          }), renderIcon(icon), children);
        }

        return React.createElement("button", __assign({}, props), renderIcon(icon), children);
      };

      var renderIcon = function renderIcon(icon) {
        return icon ? React.cloneElement(icon, {
          className: classnames(BUTTON_CLASS_NAME, icon.props.className)
        }) : null;
      };

      exports.Button.defaultProps = {
        initRipple: function initRipple() {}
      };
      exports.default = Ripple.withRipple(exports.Button);
      /***/
    }])
  );
});